function registerInputGroupClearButtons() {
  const inputClearButtons = document.querySelectorAll('.input-group-clear-button')

  inputClearButtons.forEach(inputClearButton => {
    inputClearButton.addEventListener('click', event => {
      const input = inputClearButton.parentNode.querySelector('input')
      if (input) {
        input.value = ''
        input.focus()
      }
    })
  })
}

document.addEventListener('DOMContentLoaded', (event) => {
  registerInputGroupClearButtons()
})